import background from './image/sidebar-5.jpg'
import background1 from './image/bgsidebar.png'
import Wellcome from './image/Wellcome.png'
import Loading from './image/ImageLoading.gif'
import ImageDashboard from './image/Dashboard.png'
import ImageSidebar from './image/sidebar.png'

export{
    background,
    background1,
    Wellcome,
    Loading,
    ImageDashboard,
    ImageSidebar
}


// WEBPACK FOOTER //
// ./src/assets/index.js